import Image from "next/image"
import styles from "./ContactPage.module.scss"
import Head from "next/head"
import { useForm } from "react-hook-form"
import { Button, TextField } from "@mui/material"
import { useCallback } from "react"
import { SuccessView } from "./SuccessView"
import { sendTomboHomePageMessage } from "./ContactPage.api"
import { validate as validateEmail } from "email-validator"
import MuiThemeProvider from "@web/components/Forms/MuiThemeProvider"
import { APP_DISPLAY_NAME } from "platform-common/index"

type ContactForm = {
  email: string
  message: string
}

export const ContactPage = () => {
  const form = useForm<ContactForm>()

  const handleSubmit = useCallback(async (form: ContactForm) => {
    await sendTomboHomePageMessage({
      contactRequest: { email: form.email, message: form.message },
    })
  }, [])

  const isFormSubmitted = form.formState.isSubmitSuccessful

  return (
    <MuiThemeProvider>
      <div className={styles.root}>
        <Head>
          <link rel="canonical" href="https://tombo.ai/contact" />
        </Head>

        <Image
          src="/images/landing/Tombo-tomboLogo.svg"
          alt={`${APP_DISPLAY_NAME} Logo`}
          className={styles.logoImage}
          width={41}
          height={46}
          draggable={false}
        />

        {isFormSubmitted ? (
          <SuccessView />
        ) : (
          <form onSubmit={form.handleSubmit(handleSubmit)}>
            <TextField
              label="Your Email"
              error={!!form.formState.errors.email}
              {...form.register("email", { validate: validateEmail })}
            />
            <TextField
              label="Your Message"
              error={!!form.formState.errors.message}
              multiline
              {...form.register("message", { required: true })}
            />
            <Button type="submit">Send</Button>
          </form>
        )}
      </div>
    </MuiThemeProvider>
  )
}
